import React, { useEffect, useState } from "react";
import { Button, Card, Col, Row, Typography } from "antd";
import { Link } from "react-router-dom";
import { api } from "../services/api";
import { resolveProductImage } from "../utils/productAssets";
import { renderHtml } from "../utils/renderHtml";
import { getDisplaySoldCount } from "../utils/displaySoldCount";

const { Title } = Typography;
const colors = ["#3689CD", "#70C6FE", "#3A8BCD"];

function Mainproduct() {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    let mounted = true;
    api.get("/listings?section=machines&limit=3")
      .then((data) => {
        if (mounted) setProducts(data.products || []);
      })
      .catch(() => {
        if (mounted) setProducts([]);
      });
    return () => {
      mounted = false;
    };
  }, []);

  if (!products.length) return null;

  return (
    <div style={{ padding: "48px 16px" }}>
      <div className="container">
        <Row gutter={[24, 24]} justify="center">
          {products.map((product, index) => {
            const bg = colors[index % colors.length];
            const soldCount = getDisplaySoldCount(product);
            return (
              <Col key={product._id || product.sku} xs={24} sm={12} md={8}>
                <Card
                  bordered={false}
                  style={{
                    background: bg,
                    borderRadius: 18,
                    height: "100%",
                    boxShadow: "0 6px 28px rgba(0,90,160,0.15)",
                    textAlign: "center",
                    overflow: "hidden",
                  }}
                  bodyStyle={{ padding: "0px 24px 24px" }}
                  cover={
                    <div style={{ background: bg, height: 200, display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
                      <img src={resolveProductImage(product.image)} alt={product.name} style={{ maxHeight: 160, borderRadius: 12, maxWidth: "90%", objectFit: "contain" }} />
                    </div>
                  }
                >
                  <Title level={4} style={{ color: "#fff", marginBottom: 8, fontWeight: 700, fontFamily: "Gopher" }}>
                    {product.name}
                  </Title>
                  <p className="mt-2 max-w-md text-sm leading-6 text-white/85" dangerouslySetInnerHTML={renderHtml(product.shortDescription)} />
                  <p className="mt-3 text-xs font-bold uppercase tracking-widest text-white/80">
                    {Number(product.reviewCount || 0)} review{Number(product.reviewCount || 0) === 1 ? "" : "s"}
                    {` · ${soldCount} sold`}
                  </p>
                  <Link to={`/products/${product.slug || product.sku}`}>
                    <Button shape="round" style={{ background: "#fff", color: bg, border: "none", fontWeight: 700, padding: "0 32px", height: 38, fontFamily: "gopher, sans-serif" }}>
                      Shop Now
                    </Button>
                  </Link>
                </Card>
              </Col>
            );
          })}
        </Row>
      </div>
    </div>
  );
}

export default Mainproduct;
